<template>
  <div class="animated fadeIn">
    <server-side-paginated-table
            :fields="table_settings.fields"
            :api_url="table_settings.api_url"
            :delete_url="table_settings.delete_url"
            ref="displayTable"
    />
  </div>
</template>
<script>
    import {bus} from '@/main.js';
    import ServerSidePaginatedTable from '@/views/helpers/ServerSidePaginatedTable.vue';
    export default {
      components: {ServerSidePaginatedTable},
      data: () => {
          return {
              table_settings:{
                  api_url:'leave-applications/all',
                  delete_url:'maintenance/preference_categories/delete',
                  fields:[
                    {key: 'manpower.full_name', label:'Employee'},
                    {key: 'leave_benefit.description', label:'Applied Leave'},
                    {key: 'date.other_formats.format_1', label:'Date'},
                    {key: 'qty', label:'Qty'},
                    {key: 'status_description', label:'Status'},
                  ]
              },
          }
      },
      created(){
        bus.$on('serverSidePaginatedTableDbClick', (data)=>{
            this.$router.push('/manpowers/leave-applications/update/'+data.id);
        });
      }
    }
</script>
